function getCount(element: HTMLElement): Record<string, number> {
    const src: Record<string, number> = {
        rowCount: 0,
        columnCount: 0,
    };

    const elTableBody = element.querySelector('tbody');

    if (elTableBody) {
        src.rowCount = elTableBody.rows.length;
        src.columnCount = elTableBody.rows.length ? elTableBody.rows[0].cells.length : 0;
    }

    return src;
}

// ----------------------------------------------------------------------------

export default getCount;
